import { BossModeTrack } from '../../types';

export type BossModeTrackTable = Pick<
  BossModeTrack,
  | 'eventType'
  | 'user'
  | 'leadNames'
  | 'dealRoomNames'
  | 'previousNdaStatus'
  | 'createdAt'
>;

export type BossModeTrackTableKeys = Array<keyof BossModeTrackTable>;

export const TABLE_COLUMNS: BossModeTrackTableKeys = [
  'eventType',
  'user',
  'leadNames',
  'dealRoomNames',
  'previousNdaStatus',
  'createdAt',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  eventType: 'eventType',
  user: 'bossMode',
  leadNames: 'lead',
  dealRoomNames: 'deal',
  previousNdaStatus: 'ndaStatus',
  createdAt: 'time',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  user: 300,
  leadNames: 250,
  dealRoomNames: 300,
  previousNdaStatus: 200,
  createdAt: 130,
};

// Maps column key → backend sort field name.
// Note: NDA Status column sorts by newNdaStatus per design spec.
export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  eventType: 'eventType',
  user: 'user',
  leadNames: 'buyerName',
  dealRoomNames: 'dealRoomName',
  previousNdaStatus: 'newNdaStatus',
  createdAt: 'createdAt',
};

// Options for the MultiSort modal — label values are i18n keys, translated at usage site.
export const MULTI_SORT_VALUES: Array<{ value: string; label: string }> = [
  { value: 'eventType', label: 'eventType' },
  { value: 'user', label: 'bossMode' },
  { value: 'buyerName', label: 'lead' },
  { value: 'dealRoomName', label: 'deal' },
  { value: 'newNdaStatus', label: 'ndaStatus' },
  { value: 'createdAt', label: 'time' },
];

export const DEFAULT_SORT = '-createdAt';

export const LOCKED_COLUMN = 'eventType';
